import { Col, DatePicker, Flex, Typography, message, Select, Button, Slider, Row, Tooltip, Image, Empty, Modal, Spin } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { EyeOutlined, EyeInvisibleOutlined, HeatMapOutlined } from "@ant-design/icons";
import "antd/dist/reset.css";
import axiosClient from "../../../Authentication/ApiCall";
import dayjs from "dayjs";
import moment from "moment";
import socket from "../../../../Socket";
import useInterval from "use-interval";
import authService from "../../../Authentication/authService";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { set } from "lodash";

const useExactInterval_Dwell = (callback) => {
    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const getNextIntervalTime_Dwell = () => {
            const now = new Date();
            const minutes = now.getMinutes();
            const nextMinutes = Math.ceil(minutes / 5) * 5;
            const nextRun = new Date(now);
            nextRun.setMinutes(nextMinutes);
            nextRun.setSeconds(0);
            nextRun.setMilliseconds(0);

            if (nextRun <= now) {
                nextRun.setMinutes(nextRun.getMinutes() + 5);
            }

            return nextRun - now;
        };

        timeoutRef.current = setTimeout(() => {
            callback();
            intervalRef.current = setInterval(callback, 5 * 60 * 1000);
        }, getNextIntervalTime_Dwell());      
       
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [callback]);
};

const useExactInterval_Crowd = (callback) => {
    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const getNextIntervalTime_Crowd = () => {
            const now = new Date();
            const minutes = now.getMinutes();
            const nextMinutes = Math.ceil(minutes / 3) * 3;
            const nextRun = new Date(now);
            nextRun.setMinutes(nextMinutes);
            nextRun.setSeconds(0);
            nextRun.setMilliseconds(0);

            if (nextRun <= now) {
                nextRun.setMinutes(nextRun.getMinutes() + 3);
            }

            return nextRun - now;
        };

        timeoutRef.current = setTimeout(() => {
            callback();
            intervalRef.current = setInterval(callback, 3 * 60 * 1000);
        }, getNextIntervalTime_Crowd());      
       
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [callback]);
};

const FloorMap = (props) => {
    const [rangePicker, setRangePicker] = useState({
        startDate: dayjs().format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
    });
    // const [Stores, setStores] = useState([]);
    const [svgPreview, setSvgPreview] = useState(null);
    const [overlayLabels, setOverlayLabels] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedZones, setSelectedZones] = useState(null);
    const [coordinates, setCoordinates] = useState([]);
    const [dwelldata, setDwellData] = useState([]);
    // const [cameraHovered, setcameraHovered] = useState(false);
    // const [maxHovered, setMaxHovered] = useState(false);
    // const [minHovered, setMinHovered] = useState(false);
    // const [avgHovered, setavgHovered] = useState(false);
    const [cameraLabelsVisible, setCameraLabelsVisible] = useState(false);
    const [maxLabelsVisible, setMaxLabelsVisible] = useState(false);
    const [minLabelsVisible, setMinLabelsVisible] = useState(false);
    const [avgLabelsVisible, setAvgLabelsVisible] = useState(false);
    const [liveOccupancyLabelsVisible, setLiveOccupancyLabelsVisible] = useState(false);
    const [currentliveOccupancyLabelsVisible, setCurentLiveOccupancyLabelsVisible] = useState(true);
    const [liveOccupancyValues, setLiveOccupancyValues] = useState([]);
    const [hourValue, setHourValue] = useState(1);
    const [dateSliderValue, setDateSliderValue] = useState(1); 
    const [dateValue, setDateValue] = useState(new Date(rangePicker.startDate)); 
    const [maxLabelsValue, setMaxLabelsValue] = useState(1);
    const [minLabelsValue, setMinLabelsValue] = useState(1);
    const [avgLabelsValue, setAvgLabelsValue] = useState(1);
    const [liveOccupancyLabelsValue, setLiveOccupancyLabelsValue] = useState(1);
    const [socketUpdate, setSocketUpdate] = useState(1);
    const [diffdays, setdiffdays] = useState();
    const [hours, setHours] = useState({});
    const [days, setdays] = useState();
    const [selectedOptionFlag, setSelectedOptionFlag] = useState(null);
    const [maxHour, setMaxHour] = useState(new Date().getHours() + 1)
    const [cameraHeatMap, setCameraHeatMap] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [dwellCameraIds, setDwellCameraIds] = useState([]);
    var socketcheck_dwell = false
    var socketcheck_crowd = false
    const { Title, Text } = Typography;
    const { Option } = Select;
    const { RangePicker } = DatePicker;
    const dateFormat = "YYYY-MM-DD";

    const canvasRef = useRef(null);
    const carouselRef = useRef(null);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

    const onMainRangeChange = (date) => {
        if (date === null || date === "") {
            setRangePicker((prevState) => ({
                ...prevState,
            }));
        } else {
            setRangePicker((prevState) => ({
                ...prevState,
                startDate: dayjs(date[0]).format("YYYY-MM-DD"),
                endDate: dayjs(date[1]).format("YYYY-MM-DD"),
            }));
        }
    };

    const onclickcamera = () => {
        cameraLabelsVisible === false ? setCameraLabelsVisible(true) : setCameraLabelsVisible(false)
    }

    const onclickmax = () => {    
        setMaxLabelsValue(maxLabelsValue + 1)     
        if(maxLabelsVisible === false)
        {
            setMaxLabelsVisible(true)                    
        }
        else {
            setMaxLabelsVisible(false)
        }
    }

    const onclickmin = () => {      
        setMinLabelsValue(minLabelsValue + 1)      
        if(minLabelsVisible === false)
        {
            setMinLabelsVisible(true)              
        }
        else {
            setMinLabelsVisible(false)
        }
    }

    const onclickavg = () => {  
        setAvgLabelsValue(avgLabelsValue + 1)      
        if (avgLabelsVisible === false) {           
            setAvgLabelsVisible(true)           
        }
        else {
            setAvgLabelsVisible(false)
        }
    }

    const onclickliveoccupancy = () => {  
        setLiveOccupancyLabelsValue(liveOccupancyLabelsValue + 1)      
        if (liveOccupancyLabelsVisible === false) {           
            setLiveOccupancyLabelsVisible(true)           
        }
        else {
            setLiveOccupancyLabelsVisible(false)
        }
    }

    const handleHourSliderChange = (value) => {
        if ((rangePicker.startDate === rangePicker.endDate) && (moment().format("YYYY-MM-DD") === rangePicker.endDate)) {
            if (liveOccupancyLabelsVisible) {
                if (value !== maxHour) {
                    setLiveOccupancyLabelsValue(liveOccupancyLabelsValue + 1)
                    setLiveOccupancyLabelsVisible(false)
                }
            }
            else {
                if (value === maxHour) {
                    setLiveOccupancyLabelsValue(liveOccupancyLabelsValue + 1)
                }
            }
        }
        else {
            setLiveOccupancyValues([])
            setLiveOccupancyLabelsVisible(false)
            setCurentLiveOccupancyLabelsVisible(false)
        }
        setHourValue(value);
        if (maxLabelsVisible) {
            setMaxLabelsValue(maxLabelsValue + 1)
        }
        if (minLabelsVisible) {
            setMinLabelsValue(minLabelsValue + 1)
        }
        if (avgLabelsVisible) {
            setAvgLabelsValue(avgLabelsValue + 1)
        }        
    };

    const handleDateSliderChange = (value) => {         
        const selectedDate = new Date(new Date(rangePicker.startDate));
        selectedDate.setDate(new Date(rangePicker.startDate).getDate() + (value - 1));        
        setDateValue(selectedDate);
        setDateSliderValue(value)
        if (maxLabelsVisible) {
            setMaxLabelsValue(maxLabelsValue + 1)
        }
        if (minLabelsVisible) {
            setMinLabelsValue(minLabelsValue + 1)
        }
        if (avgLabelsVisible) {
            setAvgLabelsValue(avgLabelsValue + 1)
        }
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleImageLoad = (e) => {
        setLoading(false);
        const { naturalWidth, naturalHeight } = e.target;
        setImageDimensions({ width: naturalWidth, height: naturalHeight });
    };

    const getrbgvalues = (i, red, green, blue, dwell_value, keys) => {

        if (i + 1 === 1) {
            red = 255
            green = 0
            blue = 0
        }
        else if (keys.length === 2) {
            if (i + 1 === 2) {
                red = 0
                green = 255
                blue = 0
            }
        } else if (keys.length === 3) {
            if (i + 1 === 2) {
                red = 0
                green = 255
                blue = 0
            }
            else {
                red = 0
                green = 0
                blue = 255
            }
        } else if (keys.length === 4) {
            if (i + 1 === 2) {
                red = 127
                green = 127
                blue = 0
            }
            else if (i + 1 === 3) {
                red = 0
                green = 255
                blue = 127
            } else {
                red = 0
                green = 0
                blue = 255
            }
        } else if (keys.length === 5) {
            if (i + 1 === 2) {
                red = 127
                green = 127
                blue = 0
            }
            else if (i + 1 === 3) {
                red = 0
                green = 255
                blue = 127
            } else if (i + 1 === 4) {
                red = 0
                green = 255
                blue = 0
            } else {
                red = 0
                green = 0
                blue = 255
            }
        } else if (keys.length % 2 === 0) {
            if (red !== 0) {
                red = 255 - (255 / (((keys.length - 2) / 2))) * ((i + 1) - 1)
            }
            if (green !== 255 && blue === 0) {
                green = (255 / (((keys.length - 2) / 2))) * ((i + 1) - 1)
            }
            else {
                green = 255 - ((255 / ((keys.length - 2) / 2))) * ((i + 1) - (keys.length / 2))
                blue = ((255 / ((keys.length - 2) / 2))) * ((i + 1) - (keys.length / 2))
            }
            if (Math.sign(red) === -1 || Math.sign(red) === 0) {
                red = 0
            }
            if (green > 255) {
                green = 255
            }
            if (Math.sign(green) === -1 || Math.sign(green) === 0) {
                green = 0
            }
            if (blue > 255) {
                blue = 255
            }
        } else if (keys.length % 2 !== 0) {
            if (red !== 0) {
                red = 255 - (255 / ((((keys.length - 1) - 2) / 2))) * ((i + 1) - 1)
            }
            if (green !== 255 && blue === 0) {
                green = (255 / ((((keys.length - 1) - 2) / 2))) * ((i + 1) - 1)
            }
            else {
                green = 255 - ((255 / ((keys.length - 1) / 2))) * ((i + 1) - (keys.length / 2))
                blue = ((255 / ((keys.length - 1) / 2))) * ((i + 1) - (keys.length / 2))
            }
            if (Math.sign(red) === -1 || Math.sign(red) === 0) {
                red = 0
            }
            if (green > 255) {
                green = 255
            }
            if (Math.sign(green) === -1 || Math.sign(green) === 0) {
                green = 0
            }
            if (blue > 255) {
                blue = 255
            }
        }
        if (dwell_value === 0) {
            red = 0
            green = 0
            blue = 255
        }
        return {red, green, blue}
    }

    const getClosestPoint = (a, points) => {
        let closestPoint = null;
        let minDistance = Infinity;
        let radius = 15;
        points.forEach(point => {
            const distance = Math.sqrt(
                Math.pow(point.x - a.x, 2) + Math.pow(point.y - a.y, 2)
            );
            if (distance <= radius) {
                if(distance < minDistance)
                {
                    minDistance = distance;
                    closestPoint = point;
                }            
            }
        });
        return closestPoint;
    };      

    const handleSvgClick = (event) => {
        setCameraHeatMap(null)
        if ((rangePicker.startDate === rangePicker.endDate) && (moment().format("YYYY-MM-DD") !== rangePicker.endDate)) {
            const rect = event.target.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            const closestPoint = getClosestPoint({ x: x, y: y }, coordinates);
            if (closestPoint != null) {
                axiosClient
                    .get(
                        `/flooronboard/getcameraheatmap?cameraId=${closestPoint.cameraId}&startdate=${rangePicker.startDate}`
                    )
                    .then((response) => {
                        if (response.data.issuccess === true) {
                            if (response.data.data) {
                                setCameraHeatMap(response.data.data)
                                setIsModalOpen(true);
                            }
                        }
                        else {
                            message.info(response.data.msg)
                        }
                    }).catch((err) => {
                        if (err.status === 0) {
                            message.error("Server error");
                        } else {
                            message.error(err.msg);
                        }
                    });
            }
        }
        else if ((rangePicker.startDate !== rangePicker.endDate)) {
            const rect = event.target.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            const closestPoint = getClosestPoint({ x: x, y: y }, coordinates);
            if (closestPoint != null) {
                axiosClient
                    .get(
                        `/flooronboard/getcameraheatmap?cameraId=${closestPoint.cameraId}&startdate=${dateValue}`
                    )
                    .then((response) => {
                        if (response.data.issuccess === true) {
                            if (response.data.data) {
                                setCameraHeatMap(response.data.data)
                                setIsModalOpen(true);
                            }                           
                        }
                        else {
                            message.info(response.data.msg)
                        }
                    }).catch((err) => {
                        if (err.status === 0) {
                            message.error("Server error");
                        } else {
                            message.error(err.msg);
                        }
                    });
            }
        }
    };

    const handleClose = () => {
        setIsModalOpen(false);
    };

    const generateGradient = (startColor, endColor, steps) => {
        const start = {
            r: parseInt(startColor.slice(1, 3), 16),
            g: parseInt(startColor.slice(3, 5), 16),
            b: parseInt(startColor.slice(5, 7), 16),
        };
    
        const end = {
            r: parseInt(endColor.slice(1, 3), 16),
            g: parseInt(endColor.slice(3, 5), 16),
            b: parseInt(endColor.slice(5, 7), 16),
        };
    
        const step = {
            r: (end.r - start.r) / (steps - 1),
            g: (end.g - start.g) / (steps - 1),
            b: (end.b - start.b) / (steps - 1),
        };
    
        const colors = [];
        for (let i = 0; i < steps; i++) {
            colors.push(
                `rgb(${Math.round(start.r + step.r * i)}, ${Math.round(start.g + step.g * i)}, ${Math.round(start.b + step.b * i)})`
            );
        }
        return colors;
    };

    const previmage = () => {
        const prevcameraid = cameraHeatMap.cameraId == dwellCameraIds[0] ? dwellCameraIds[dwellCameraIds.length - 1] : dwellCameraIds[dwellCameraIds.findIndex(item => item == cameraHeatMap.cameraId) - 1]
        if ((rangePicker.startDate === rangePicker.endDate) && (moment().format("YYYY-MM-DD") !== rangePicker.endDate)) {
            axiosClient
                .get(
                    `/flooronboard/getcameraheatmap?cameraId=${prevcameraid}&startdate=${rangePicker.startDate}`
                )
                .then((response) => {
                    if (response.data.issuccess === true) {
                        if (response.data.data) {
                            setCameraHeatMap(response.data.data)
                            setIsModalOpen(true);
                        }
                    }
                    else {
                        message.info(response.data.msg)
                    }
                }).catch((err) => {
                    if (err.status === 0) {
                        message.error("Server error");
                    } else {
                        message.error(err.msg);
                    }
                });

        }
        else if ((rangePicker.startDate !== rangePicker.endDate)) {
            axiosClient
                .get(
                    `/flooronboard/getcameraheatmap?cameraId=${prevcameraid}&startdate=${dateValue}`
                )
                .then((response) => {
                    if (response.data.issuccess === true) {
                        if (response.data.data) {
                            setCameraHeatMap(response.data.data)
                            setIsModalOpen(true);
                        }
                    }
                    else {
                        message.info(response.data.msg)
                    }
                }).catch((err) => {
                    if (err.status === 0) {
                        message.error("Server error");
                    } else {
                        message.error(err.msg);
                    }
                });
        }
    }

    const nextimage = () => {
        const prevcameraid = cameraHeatMap.cameraId == dwellCameraIds[dwellCameraIds.length - 1] ? dwellCameraIds[0] : dwellCameraIds[dwellCameraIds.findIndex(item => item == cameraHeatMap.cameraId) + 1]
        if ((rangePicker.startDate === rangePicker.endDate) && (moment().format("YYYY-MM-DD") !== rangePicker.endDate)) {
            axiosClient
                .get(
                    `/flooronboard/getcameraheatmap?cameraId=${prevcameraid}&startdate=${rangePicker.startDate}`
                )
                .then((response) => {
                    if (response.data.issuccess === true) {
                        if (response.data.data) {
                            setCameraHeatMap(response.data.data)
                            setIsModalOpen(true);
                        }
                    }
                    else {
                        message.info(response.data.msg)
                    }
                }).catch((err) => {
                    if (err.status === 0) {
                        message.error("Server error");
                    } else {
                        message.error(err.msg);
                    }
                });

        }
        else if ((rangePicker.startDate !== rangePicker.endDate)) {
            axiosClient
                .get(
                    `/flooronboard/getcameraheatmap?cameraId=${prevcameraid}&startdate=${dateValue}`
                )
                .then((response) => {
                    if (response.data.issuccess === true) {
                        if (response.data.data) {
                            setCameraHeatMap(response.data.data)
                            setIsModalOpen(true);
                        }
                    }
                    else {
                        message.info(response.data.msg)
                    }
                }).catch((err) => {
                    if (err.status === 0) {
                        message.error("Server error");
                    } else {
                        message.error(err.msg);
                    }
                });
        }
    }

    function getDwellCameraForHour(hour) {
        const cameras = dwelldata[hour];
        if (!cameras) {
            return null;
        }

        const cameraEntries = Object.entries(cameras);

        cameraEntries.sort((a, b) => b[1].totalmax - a[1].totalmax);

        const maxgrouped = cameraEntries.reduce((acc, [id, data]) => {
            const totalmax = data.totalmax;
            if (!acc[totalmax]) {
              acc[totalmax] = { totalmax, cameraids: [] };
            }
            acc[totalmax].cameraids.push(parseInt(id)); 
            return acc;
          }, {});

        cameraEntries.sort((a, b) => b[1].totalmin - a[1].totalmin);

        const mingrouped = cameraEntries.reduce((acc, [id, data]) => {
            const totalmin = data.totalmin;
            if (!acc[totalmin]) {
                acc[totalmin] = { totalmin, cameraids: [] };
            }
            acc[totalmin].cameraids.push(parseInt(id));
            return acc;
        }, {});

        cameraEntries.sort((a, b) => b[1].totalavg - a[1].totalavg);

        const avggrouped = cameraEntries.reduce((acc, [id, data]) => {
            const totalavg = data.totalavg;
            if (!acc[totalavg]) {
                acc[totalavg] = { totalavg, cameraids: [] };
            }
            acc[totalavg].cameraids.push(parseInt(id));
            return acc;
        }, {});

        return {maxgrouped, mingrouped, avggrouped};
    }

    function getDwellCameraForDate(date) {
        const cameras = dwelldata[formatDate(date)];
        if (!cameras) {
            return null;
        }

        const cameraEntries = Object.entries(cameras);

        cameraEntries.sort((a, b) => b[1].totalmax - a[1].totalmax);

        const maxgrouped = cameraEntries.reduce((acc, [id, data]) => {
            const totalmax = data.totalmax;
            if (!acc[totalmax]) {
              acc[totalmax] = { totalmax, cameraids: [] };
            }
            acc[totalmax].cameraids.push(parseInt(id)); 
            return acc;
          }, {});

        cameraEntries.sort((a, b) => b[1].totalmin - a[1].totalmin);

        const mingrouped = cameraEntries.reduce((acc, [id, data]) => {
            const totalmin = data.totalmin;
            if (!acc[totalmin]) {
                acc[totalmin] = { totalmin, cameraids: [] };
            }
            acc[totalmin].cameraids.push(parseInt(id));
            return acc;
        }, {});

        cameraEntries.sort((a, b) => b[1].totalavg - a[1].totalavg);

        const avggrouped = cameraEntries.reduce((acc, [id, data]) => {
            const totalavg = data.totalavg;
            if (!acc[totalavg]) {
                acc[totalavg] = { totalavg, cameraids: [] };
            }
            acc[totalavg].cameraids.push(parseInt(id));
            return acc;
        }, {});           

        return {maxgrouped, mingrouped, avggrouped};
    }

    useEffect( () => {
        let values = null
        if (rangePicker.startDate === rangePicker.endDate) {
            values = dwelldata[parseInt(hourValue)];
        }
        else {
            values = dwelldata[formatDate(dateValue)];
        }
        if (values === undefined) {
            values = null
        }
        //var values = getDwellCameraForHour(parseInt(hourValue))
        if (values != null || liveOccupancyValues.length > 0) {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            if(values != null)
            {
                if (maxLabelsVisible) {
                    if (Object.keys(values.maxgrouped).length !== 0) {
                        const object_keys = Object.keys(values.maxgrouped).map((item) => parseFloat(item)).sort((a, b) => b - a)
                        let red = 255
                        let green = 0
                        let blue = 0
                        for (let i = 0; i < object_keys.length; i++) {
                            let radius = parseFloat(35 - (parseFloat(20 / object_keys.length).toFixed(2)* i)).toFixed(2)                           
                            const matched_value = values.maxgrouped[object_keys[i]]
                            if (matched_value !== undefined && matched_value != null) {                                
                                let dwell_value = 0
                                if (matched_value.totalmax == 0) {
                                    dwell_value = 0
                                }
                                else {
                                    dwell_value = Math.abs(parseFloat((parseFloat(matched_value.totalmax) - object_keys[object_keys.length - 1]) / (parseFloat(object_keys[0]) - object_keys[object_keys.length - 1])))
                                }
                                let rbg_values = getrbgvalues(i, red, green, blue, dwell_value, object_keys)
                                if (dwell_value === 0) {
                                    red = 0
                                    green = 0
                                    blue = 255
                                } else {
                                    red = rbg_values.red
                                    green = rbg_values.green
                                    blue = rbg_values.blue
                                }
    
                                for (let j = 0; j < matched_value.cameraids.length; j++) {
                                    //let radius = parseFloat((35 / 100) * ((matched_value.totalmax / values.maxgrouped[object_keys[0]].totalmax) * 100))                                                                 
                                    const draw_circle = coordinates.find((item) => item.cameraId === parseInt(matched_value.cameraids[j]))
                                    if (draw_circle !== undefined && draw_circle != null) {
                                        ctx.beginPath();
                                        ctx.arc(draw_circle.x, draw_circle.y, radius, 0, Math.PI * 2);
                                        ctx.fillStyle = `rgba(${red}, ${green}, ${blue}, 0.5)`;
                                        ctx.fill();
    
                                        // ctx.fillStyle = "white";
                                        // ctx.font = "12px Arial";
                                        // ctx.textAlign = "center";
                                        // ctx.textBaseline = "middle";
    
                                        // ctx.fillText(matched_value.totalmax, draw_circle.x, draw_circle.y);
                                    }
                                }
                            }
                        }
                    }
                }
    
                if (minLabelsVisible) {
                    if (Object.keys(values.mingrouped).length !== 0) {
                        const object_keys = Object.keys(values.mingrouped).map((item) => parseFloat(item)).sort((a, b) => b - a)
                        let red = 255
                        let green = 0
                        let blue = 0
                        for (let i = 0; i < object_keys.length; i++) {
                            let radius = parseFloat(35 - (parseFloat(20 / object_keys.length).toFixed(2)* i)).toFixed(2)                           
                            const matched_value = values.mingrouped[object_keys[i]]
                            if (matched_value !== undefined && matched_value != null) {                               
                                let dwell_value = 0
                                if (matched_value.totalmin == 0) {
                                    dwell_value = 0
                                }
                                else {
                                    dwell_value = Math.abs(parseFloat((parseFloat(matched_value.totalmin) - object_keys[object_keys.length - 1]) / (parseFloat(object_keys[0]) - object_keys[object_keys.length - 1])))
                                }
                                let rbg_values = getrbgvalues(i, red, green, blue, dwell_value, object_keys)
                                if (dwell_value === 0) {
                                    red = 0
                                    green = 0
                                    blue = 255
                                } else {
                                    red = rbg_values.red
                                    green = rbg_values.green
                                    blue = rbg_values.blue
                                }
    
                                for (let j = 0; j < matched_value.cameraids.length; j++) {
                                    //let radius = parseFloat((35 / 100) * ((matched_value.totalmin / values.mingrouped[object_keys[0]].totalmin) * 100))
                                    const draw_circle = coordinates.find((item) => item.cameraId === parseInt(matched_value.cameraids[j]))
                                    if (draw_circle !== undefined && draw_circle != null) {
                                        ctx.beginPath();
                                        ctx.arc(draw_circle.x, draw_circle.y, radius, 0, Math.PI * 2);
                                        ctx.fillStyle = `rgba(${red}, ${green}, ${blue}, 0.5)`;
                                        ctx.fill();
    
                                        // ctx.fillStyle = "black";
                                        // ctx.font = "12px Arial";
                                        // ctx.textAlign = "center";
                                        // ctx.textBaseline = "middle";
    
                                        // ctx.fillText(matched_value.totalmin, draw_circle.x, draw_circle.y);
                                    }
                                }
                            }
                        }
                    }
                }
    
                if (avgLabelsVisible) {
                    if (Object.keys(values.avggrouped).length !== 0) {
                        const object_keys = Object.keys(values.avggrouped).map((item) => parseFloat(item)).sort((a, b) => b - a)
                        let red = 255
                        let green = 0
                        let blue = 0
                        for (let i = 0; i < object_keys.length; i++) {
                            let radius = parseFloat(35 - (parseFloat(20 / object_keys.length).toFixed(2)* i)).toFixed(2)                         
                            const matched_value = values.avggrouped[object_keys[i]]
                            if (matched_value !== undefined && matched_value != null) {                                
                                let dwell_value = 0
                                if (matched_value.totalavg == 0) {
                                    dwell_value = 0
                                }
                                else {
                                    dwell_value = Math.abs(parseFloat((parseFloat(matched_value.totalavg) - object_keys[object_keys.length - 1]) / (parseFloat(object_keys[0]) - object_keys[object_keys.length - 1])))
                                }
                                let rbg_values = getrbgvalues(i, red, green, blue, dwell_value, object_keys)
                                if (dwell_value === 0) {
                                    red = 0
                                    green = 0
                                    blue = 255
                                } else {
                                    red = rbg_values.red
                                    green = rbg_values.green
                                    blue = rbg_values.blue
                                }
    
                                for (let j = 0; j < matched_value.cameraids.length; j++) {
                                    //let radius = parseFloat((35 / 100) * ((matched_value.totalavg / values.avggrouped[object_keys[0]].totalavg) * 100))
                                    const draw_circle = coordinates.find((item) => item.cameraId === parseInt(matched_value.cameraids[j]))
                                    if (draw_circle !== undefined && draw_circle != null) {
                                        ctx.beginPath();
                                        ctx.arc(draw_circle.x, draw_circle.y, radius, 0, Math.PI * 2);
                                        ctx.fillStyle = `rgba(${red}, ${green}, ${blue}, 0.5)`;
                                        ctx.fill();
    
                                        // ctx.fillStyle = "white";
                                        // ctx.font = "12px Arial";
                                        // ctx.textAlign = "center";
                                        // ctx.textBaseline = "middle";
    
                                        // ctx.fillText(matched_value.totalavg, draw_circle.x, draw_circle.y);
                                    }
                                }
                            }
                        }
                    }
                }
            }            

            if (liveOccupancyLabelsVisible) {
                let red = 255
                let green = 255
                let blue = 255
                for (let j = 0; j < dwellCameraIds.length; j++) {
                    let radius = 17
                    const draw_circle = coordinates.find((item) => item.cameraId === parseInt(dwellCameraIds[j]))
                    const livecount = liveOccupancyValues.find((item) => item.cameraId === parseInt(dwellCameraIds[j]))
                    if (draw_circle !== undefined && draw_circle != null) {
                        ctx.beginPath();
                        ctx.arc(draw_circle.x, draw_circle.y, radius, 0, Math.PI * 2);
                        ctx.fillStyle = `rgba(${red}, ${green}, ${blue}, 0.7)`;
                        ctx.fill();

                        ctx.fillStyle = "Black";
                        ctx.font = "17px Arial";
                        ctx.textAlign = "center";
                        ctx.textBaseline = "middle";

                        ctx.fillText(livecount !== undefined && livecount != null ? livecount.count : 0, draw_circle.x, draw_circle.y);
                    }
                }                                  
            }
        }    
    }, [maxLabelsValue, minLabelsValue, avgLabelsValue, liveOccupancyLabelsValue, socketUpdate]) 

    useEffect(() => {           
        if (selectedOption != null) {
            if (selectedZones === null && (selectedOptionFlag !== null ? selectedOptionFlag === selectedOption ? true : false : false) === false) {
                setSvgPreview([])
                setLoading(true)
            }   
            axiosClient
                .get(
                    `/flooronboard/getfloordwelldetails?id=${selectedOption}&startdate=${rangePicker.startDate}&enddate=${rangePicker.endDate}&zonecameraIds=${selectedZones ? selectedZones.cameraIds : null}&image=${selectedOptionFlag !== null ? selectedOptionFlag === selectedOption ? true : false : false}`
                )
                .then((response) => {
                    if (response.data.issuccess === true) {                               
                        const updatedCoordinates = response.data.floordata.cameraLocations.map((coord) => {
                            const camera = response.data.cameradata.find((camera) => camera.id === coord.cameraId);
                            return {
                                ...coord,
                                x: coord.x - 50,
                                y: coord.y - 10,
                                cameraName: camera ? camera.cameraName : null
                            };
                        });
                        setSelectedOptionFlag(selectedOption)  
                        setDwellData(response.data.dwelldata)
                        setCoordinates(response.data.floordata.cameraLocations)                       
                        setOverlayLabels(updatedCoordinates)    
                        setDwellCameraIds(response.data.dwellcameraids)                                         
                        if(selectedZones === null && (selectedOptionFlag !== null ? selectedOptionFlag === selectedOption ? true : false : false) === false)
                        {
                            setSvgPreview(response.data.floordata.floorImage)                          
                        }    
                        
                        if ((rangePicker.startDate === rangePicker.endDate) && (moment().format("YYYY-MM-DD") === rangePicker.endDate)) {
                            setLiveOccupancyValues(response.data.liveoccdata)
                            setCurentLiveOccupancyLabelsVisible(true)
                            const newHours = {};
                            for (let i = 1; i <= 24; i++) {
                              newHours[i] = `${i}`;
                            }
                            setHours(newHours);   
                            setHourValue(moment().hour() + 1)
                            setMaxLabelsValue(maxLabelsValue + 1)
                        }        
                        else if(rangePicker.startDate === rangePicker.endDate) {
                            setLiveOccupancyValues([])
                            setLiveOccupancyLabelsVisible(false)
                            setCurentLiveOccupancyLabelsVisible(false)
                            const newHours = {};
                            for (let i = 1; i <= 24; i++) {
                              newHours[i] = `${i}`;
                            }
                            setHours(newHours);    
                            setHourValue(1)
                            setMaxLabelsValue(maxLabelsValue + 1)
                        } else {    
                            setLiveOccupancyValues([])
                            setLiveOccupancyLabelsVisible(false)
                            setCurentLiveOccupancyLabelsVisible(false)
                            setDateValue(new Date(rangePicker.startDate))        
                            setdiffdays((new Date(rangePicker.endDate) - new Date(rangePicker.startDate)) / (1000 * 3600 * 24) + 1);
                            var days = {}  
                            for (let i = 0; i <= (new Date(rangePicker.endDate) - new Date(rangePicker.startDate)) / (1000 * 3600 * 24); i++) {
                                const day = new Date(rangePicker.startDate);
                                day.setDate(new Date(rangePicker.startDate).getDate() + i);
                                days[i + 1] = i + 1;
                            }    
                            setdays(days)
                            setDateSliderValue(1)
                            setMaxLabelsValue(maxLabelsValue + 1)
                        }   
                    }
                })
                .catch((err) => {
                    if (err.status === 0) {
                        message.error("Server error");
                    } else {
                        message.error(err.msg);
                    }
                });
        } 
        else {
            setLoading(false)
        }          
    }, [rangePicker.startDate, rangePicker.endDate, selectedOption, selectedZones]);

    useEffect(() => {         
        setSelectedOption(props.props[0])    
    }, [props.props[0]])

    useEffect(() => {  
        setSelectedZones(props.props[1])      
    }, [props.props[1]])


    useExactInterval_Dwell(async () => {
        if (
            rangePicker.startDate === rangePicker.endDate &&
            moment().format("YYYY-MM-DD") === rangePicker.endDate
        ) {
            let req = {
                headers: { authorization: authService.getCurrentUser() },
                query: {
                    id: selectedOption,
                    startdate: rangePicker.startDate,
                    enddate: rangePicker.endDate,
                    zonecameraIds: selectedZones ? selectedZones.cameraIds : null,
                },
            };
            socketcheck_dwell = true
            socket.emit("Floor_Map_Dwell", req);
        }
    });
      
    socket.on("Floor_map_dwell", (data) => {
        if (socketcheck_dwell === true) {
            socketcheck_dwell = false
            const updatedCoordinates = data.floordata.cameraLocations.map((coord) => {
                const camera = data.cameradata.find((camera) => camera.id === coord.cameraId);
                return {
                    ...coord,
                    x: coord.x - 50,
                    y: coord.y - 10,
                    cameraName: camera ? camera.cameraName : null
                };
            });
            if( moment().hour() == hourValue)
            {
                setHourValue(hourValue + 1)
            }       
            setDwellData(data.dwelldata)
            setCoordinates(data.floordata.cameraLocations)                       
            setOverlayLabels(updatedCoordinates)
            setSocketUpdate(socketUpdate + 1)          
        }
    })

    useExactInterval_Crowd(async () => {
        if (
            rangePicker.startDate === rangePicker.endDate &&
            moment().format("YYYY-MM-DD") === rangePicker.endDate
        ) {
            let req = {
                headers: { authorization: authService.getCurrentUser() },
                query: {
                    id: selectedOption,
                    startdate: rangePicker.startDate,
                    enddate: rangePicker.endDate,
                    zonecameraIds: selectedZones ? selectedZones.cameraIds : null,
                },
            };
            socketcheck_crowd = true
            socket.emit("Floor_Map_Crowd", req);
        }
    });

    socket.on("Floor_map_crowd", (data) => {
        if (socketcheck_crowd === true) {
            socketcheck_crowd = false
            setLiveOccupancyValues(data.liveoccdata)
            setSocketUpdate(socketUpdate + 1)
        }
    })

    const useExactIntervalHour = (callback) => {
        useEffect(() => {
            const getNextIntervalTime_hour = () => {
                const now = new Date();
                const nextRun = new Date(now);
                nextRun.setHours(now.getHours() + 1, 0, 0, 0);
    
                return nextRun - now; 
            };
    
            const timeout = setTimeout(() => {
                callback();
                const interval = setInterval(callback, 60 * 60 * 1000); 
                return () => clearInterval(interval);
            }, getNextIntervalTime_hour());
    
            return () => clearTimeout(timeout);
        }, [callback]);
    };

    useExactIntervalHour(async () => {
        setMaxHour(new Date().getHours() + 1)
    });  

    const redToGreen = generateGradient('#ff0000', '#00ff00', 15);
    const greenToBlue = generateGradient('#00ff00', '#0000ff', 15);

    const gradientColors = [...redToGreen, ...greenToBlue];

    return (
        <div
            style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                top: "10px",
                marginBottom: "10rem",
                minWidth: "1650px",
                overflowX: "auto",
            }}
        >
            {/* Top row for Date selection */}
            <Flex style={{ width: "100%", marginLeft: "130px", marginBottom: "10px" }}>
                <Col>
                    <Text style={{ fontSize: "1rem" }} strong>
                        Select Date:
                    </Text>
                </Col>
                <Col style={{ marginLeft: "10px" }}>
                    <RangePicker
                        defaultValue={[
                            dayjs(rangePicker.startDate, dateFormat),
                            dayjs(rangePicker.endDate, dateFormat),
                        ]}
                        onChange={onMainRangeChange}
                        disabledDate={(current) => current >= dayjs().endOf("day")}
                    />
                </Col>
                <Col style={{ marginLeft: "10px" }}>
                    <Button
                        type={cameraLabelsVisible === true ? "primary" : ""}
                        onClick={onclickcamera}
                        style={{ width: "100%" }}
                    >
                        Camera Details
                    </Button>
                </Col>
                <Col style={{ marginLeft: "10px" }}>
                    <Button
                        type={maxLabelsVisible === true ? "primary" : ""}
                        onClick={onclickmax}
                        style={{ width: "100%" }}
                    >
                        Max Heatmap
                    </Button>
                </Col>
                <Col style={{ marginLeft: "10px" }}>
                    <Button
                        type={minLabelsVisible === true ? "primary" : ""}
                        onClick={onclickmin}
                        style={{ width: "100%" }}
                    >
                        Min Heatmap
                    </Button>
                </Col>
                <Col style={{ marginLeft: "10px" }}>
                    <Button
                        type={avgLabelsVisible === true ? "primary" : ""}
                        onClick={onclickavg}
                        style={{ width: "100%" }}
                    >
                        Avg Heatmap
                    </Button>
                </Col>
                {currentliveOccupancyLabelsVisible && (
                    <Col style={{ marginLeft: "10px" }}>
                        <Tooltip title={hourValue === maxHour ? "" : "Live Occupancy data is only available for the current hour"}>
                        <Button
                            type={liveOccupancyLabelsVisible === true ? "primary" : ""}
                            onClick={onclickliveoccupancy}
                            style={{ width: "100%" }}    
                            disabled={hourValue === maxHour ? false : true}                         
                        >
                            Live Occupancy
                        </Button>
                        </Tooltip>
                    </Col>
                    )                    
                }
              
            </Flex>

            {/* Main content row: fixed image on left, buttons on right */}
            <Flex style={{ width: "1650px", marginLeft: "50px" }}>
                <div
                    style={{
                        width: "1650px",
                        height: "700px",
                        border: "1px solid #d9d9d9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                    }}
                >                    
                    {loading && (
                        <Spin
                            size="large"
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 999,
                            }}
                        />
                    )}

                    {maxLabelsVisible || minLabelsVisible || avgLabelsVisible ?
                         <div
                         style={{
                             position: 'absolute',
                             top: '-5px',
                             left: '50%',
                             transform: 'translateX(-50%)', // Center horizontally
                             display: 'flex',
                             alignItems: 'center',
                             padding: '5px 10px',
                             borderRadius: '4px',
                             justifyContent: 'space-between',
                             width: `${gradientColors.length * 20 + (gradientColors.length - 1) * 5}px`, // Adjust width to match the legend
                             marginBottom: '2px',
                         }}
                         >
                         <span style={{ color: 'red', fontSize: '12px' }}>High</span>
                         <span style={{ color: 'green', fontSize: '12px' }}>Medium</span>
                         <span style={{ color: 'blue', fontSize: '12px' }}>Low</span>
                        </div>
                         : <></>
                    }

                    {maxLabelsVisible || minLabelsVisible || avgLabelsVisible  ? 
                         <div
                         style={{
                             position: 'absolute',
                             top: '15px',
                             left: '50%',
                             transform: 'translateX(-50%)', // Center horizontally
                             display: 'flex',
                             alignItems: 'center',
                             background: 'rgba(255, 255, 255, 0.5)',
                             padding: '5px 10px',
                             borderRadius: '2px',
                             zIndex: 10,
                             gap: '5px',
                         }}
                     >
                         {gradientColors.map((color, index) => (
                             <div
                                 key={index}
                                 style={{
                                     width: '20px',
                                     height: '20px',
                                     backgroundColor: color,
                                     border: '1px solid #ccc',
                                     borderRadius: '2px',
                                 }}
                             />
                         ))}
                         </div>
                     : <></>}                  

                    <img
                        src={svgPreview}
                        alt="No Image Available"
                        style={{
                            width: "1650px",
                            height: "700px",
                            cursor: "pointer",
                            position: "absolute",
                            display: loading ? 'none' : 'block', 
                        }}
                        onLoad={handleImageLoad}
                        onClick={handleSvgClick}
                    />

                    <canvas
                        ref={canvasRef}
                        width={imageDimensions.width}
                        height={imageDimensions.height}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            zIndex: 1000,
                            pointerEvents: "none",
                       }}                      
                    />

                    {cameraLabelsVisible &&
                        overlayLabels.map((label, index) => (
                            <div
                                key={index}
                                style={{
                                    position: "absolute",
                                    top: `${label.y}px`,
                                    left: `${label.x}px`,
                                    background: "rgba(0, 0, 0, 0.5)",
                                    color: "#fff",
                                    padding: "2px 10px",
                                    borderRadius: "5px",
                                    pointerEvents: "none",
                                    zIndex: 600,
                                }}
                            >
                                {label.cameraName}
                            </div>
                        ))}

                    <Modal
                        open={isModalOpen}
                        footer={null}
                        closable={false} 
                        width={800}
                        style={{
                            top: 50,
                        }}
                    >
                        <Carousel showThumbs={false} ref={carouselRef}>
                            <img
                                src={cameraHeatMap != null ? "data:image/png;base64," + cameraHeatMap.heatMap : ""}
                                alt="Preview 1"
                                style={{ width: '100%', height: '400px', objectFit: 'cover' }}
                            />                            
                        </Carousel>

                        {cameraHeatMap?.cameraName && (
                            <div
                                style={{
                                    marginTop: '10px',
                                    textAlign: 'center',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    color: '#333',
                                }}
                            >
                                Camera: {cameraHeatMap.cameraName}
                            </div>
                        )}

                        <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", gap: "10px" }}>
                            <Button onClick={() => previmage()}>Previous</Button>
                            <Button onClick={() => nextimage()}>Next</Button>
                        </div>

                        <Button
                            style={{
                                position: 'absolute',
                                top: 20,
                                right: 23,
                                zIndex: 999,
                            }}
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                        </Modal>
                </div>

            </Flex>

            {/* Slider section at the bottom */}
            <Flex style={{ width: "1650px", marginLeft: "450px", marginTop: "5px" }}>
                {rangePicker.startDate === rangePicker.endDate && svgPreview && moment().format("YYYY-MM-DD") === rangePicker.endDate && (
                    <div>
                        <Slider
                            min={1}
                            max={maxHour} 
                            step={1}
                            value={hourValue}
                            onChange={handleHourSliderChange}
                            marks={Array.from({ length: maxHour }, (_, i) => i + 1).reduce((acc, val) => ({ ...acc, [val]: val }), {})}
                            open={{ visible: true, formatter: (value) => `Value: ${value}` }}
                            style={{ width: "1000px" }}
                        />
                        <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "2px" }}>
                            <h3>Hour: {hourValue}</h3>
                        </div>
                    </div>
                )}
                 {rangePicker.startDate === rangePicker.endDate && svgPreview && moment().format("YYYY-MM-DD") !== rangePicker.endDate && (
                    <div>
                        <Slider
                            min={1}
                            max={24}
                            step={1}
                            value={hourValue}
                            onChange={handleHourSliderChange}
                            marks={hours}
                            open={{ visible: true, formatter: (value) => `Value: ${value}` }}
                            style={{ width: "1000px" }}
                        />
                        <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "2px" }}>
                            <h3>Hour: {hourValue}</h3>
                        </div>
                    </div>
                )}
                {rangePicker.startDate !== rangePicker.endDate && svgPreview && (
                    <div>
                        <Slider
                            min={1}
                            max={diffdays}
                            step={1}
                            value={dateSliderValue}
                            onChange={handleDateSliderChange}
                            marks={days}
                            style={{ width: "1000px" }}
                        />
                        <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "2px" }}>
                            <h3>Date: {formatDate(dateValue)}</h3>
                        </div>
                    </div>
                )}
            </Flex>
        </div>
    );
};

export default FloorMap;
